<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="dockets.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
      class="docket-table"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="docket"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :docket="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="dockets.per_page"
        layout="total, prev, pager, next"
        :total="dockets.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      dockets() {
        return this.$store.getters['docket/dockets'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['docket/tableConfig']));
      },
      loading() {
        return this.$store.getters['docket/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('docket/setFilterString', '');
      this.$store.commit('docket/setCurrentPage', this.currentPage);
      this.$store.commit('docket/setSorting', this.currentSort);
      await this.$store.dispatch('docket/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('docket/setCurrentPage', val);
        this.$store.dispatch('docket/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('docket/setSorting', { prop, order });
          this.$store.dispatch('docket/fetchAll');
        }
      },
    },
  };
</script>
<style lang="scss">
  .docket-table {
    td {
      vertical-align: top;
    }
  }
</style>
